import request from '../../helper/request';

export function getJobOrders(params) {
  return request('/job-orders', {
    method: 'GET',
    params: params,
  });
}

export function getJobOrder(orderId) {
  return request('/job-orders/' + orderId, {
    method: 'GET',
  });
}

export function createJobOrder(params) {
  return request('/job-orders', {
    method: 'POST',
    data: params,
  });
}

export function getDirections(params) {
  return request('/common/shared-directions', {
    method: 'POST',
    data: params,
  });
}

export function getTypes() {
  return request('/job-orders/types', {
    method: 'GET',
  });
}

export function getTypesV2(params) {
  return request('/job-orders/types', {
    method: 'POST',
    data: params,
  });
}

export function getTypesV3(params) {
  return request('/job-orders/types-v3', {
    method: 'POST',
    data: params,
  });
}

export function cancelJobOrder(orderId) {
  return request('/job-orders/' + orderId + '/cancel', {
    method: 'POST',
  });
}

export function unassignJobOrder(orderId) {
  return request('/job-orders/' + orderId + '/unassign', {
    method: 'POST',
  });
}

export function exportJobOrdersCsv(params) {
  return request('/job-orders/export', {
    method: 'GET',
    params,
    responseType: 'blob',
    headers: {
      Accept: 'text/csv',
    },
  });
}
